<div class="header-wrap">
	<div class="header-inner">
		<div class="hamburger mx-2" style="display: none;">
			<button class="openbtn" (click)="toggleNavExpanded()">☰ Menu</button>
		</div>
		<div class="brand">
			<a class="brand-logo" [href]="logoRoute" title="Home">
				<img src="assets/huron-white.svg" alt="Huron Consulting Group Logo">
			</a>
			<a [routerLink]="['/']" title="Navigate to {{configService.appSettings.applicationName}} Home"
				class="brand-app">
				{{configService.appSettings.applicationName }}</a>

		</div>
		<div class="user-nav">
			<span *ngIf="user?.brandingName" class="brand-name">
				{{user?.brandingName}}</span>
			<span *ngIf="user?.brandingName" class="pipe m-hide">|</span>
			<a *ngIf="hasUserProfile" [routerLink]="['/profile']" class="user-profile">
				<span class="name">{{user?.firstName}} {{user?.lastName}}</span>
			</a>
			<a [routerLink]="['/notifications']" class="notification-bell dropdown-icon">
				<i class="icon-notifications_bell"></i> <span *ngIf="notificationCount>0" class="badge badge-number">{{notificationCount}}</span>
			</a>
			<a [routerLink]="['/logout']" class="user-logout">Logout</a>
		</div>
	</div>
</div>
